export default __webpack_public_path__ + "static/david-cc2045ca632f0d2b74f1545f943cc1e5.jpg";